module.exports = __webpack_public_path__ + "highlight-top-right.09d608.svg";